import React from 'react';
import { BridgeOverview } from '../../components/bridge/BridgeOverview';

export default function AgentDashboard() {
  return <BridgeOverview role="agent" />;
}
